import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { Delete } from '@mui/icons-material'

const DeleteCellAction: React.FC<{ onClick: () => void; tooltipLabel: string; disabled?: boolean }> = ({
  onClick,
  tooltipLabel,
  disabled = false,
}): JSX.Element => {
  return (
    <Tooltip title={tooltipLabel}>
      <div>
        <IconButton size="small" onClick={onClick} disabled={disabled} color="error" data-testid="deleteIconButton">
          <Delete sx={{ color: 'inherit !important' }} />
        </IconButton>
      </div>
    </Tooltip>
  )
}

export default DeleteCellAction
